module.exports = __webpack_public_path__ + "static/new-orleans-03a4b7b693af6f12517b73c36b374e8a.png";